if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy?.getAttribute('data-media-id');
        const content = this.querySelector('.product-media-modal__content');

        const viewer = this.querySelector('.viewer');
        const mediaImageWrapper = this.querySelector('.media_image_show');

        const setActiveElement = (element) => {
          if (!content) return;

          Array.from(content.children).forEach((child) => {
            child.classList.remove('active');
          });

          if (element) element.classList.add('active');
        };

        if (viewer && typeof viewer.setCurrentImageById === 'function' && mediaId) {
          viewer.setCurrentImageById(mediaId);
        }

        const fallbackActiveElement = mediaImageWrapper || viewer;

        if (!mediaId) {
          if (fallbackActiveElement) {
            setActiveElement(fallbackActiveElement);
          }
          return;
        }

        const allMedia = this.querySelectorAll('[data-media-id]');
        if (!allMedia.length) {
          if (fallbackActiveElement) {
            setActiveElement(fallbackActiveElement);
          }
          return;
        }

        let activeMedia = mediaId
          ? this.querySelector(`[data-media-id="${mediaId}"]`)
          : null;

        if (!activeMedia && mediaId && mediaId.includes('-')) {
          const mediaIdSuffix = mediaId.split('-').pop();
          activeMedia = this.querySelector(`[data-media-id$="-${mediaIdSuffix}"]`) ||
            this.querySelector(`[data-media-id="${mediaIdSuffix}"]`);
        }

        if (!activeMedia) {
          activeMedia = allMedia[0];
        }

        setActiveElement(activeMedia);

        if (!activeMedia) return;

        activeMedia.classList.add('active');

        if (typeof activeMedia.scrollIntoView === 'function') {
          activeMedia.scrollIntoView();
        }

        const container = this.querySelector('[role="document"]');
        if (container && activeMedia.width) {
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        const activeMediaTemplate =
          activeMedia.querySelector && activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
